import { apiConfigs } from "../../constants/apiConfigs";
import { ConversionCampaignGroupedEarning, ConversionCampaignLink } from "../../types/conversions";
import axiosClient from "../../utils/axiosClient";

export const fetchConversionCampaigns = async (payload: any): Promise<any> => {
    const response = await axiosClient.get(apiConfigs.FETCH_CONVERSION_CAMPAIGNS.url, { params: payload });
    return response.data;
}

export const fetchConversionCampaign = async (campaignId: string): Promise<any> => {
    const response = await axiosClient.get(apiConfigs.FETCH_CONVERSION_CAMPAIGN.url.replace('<campaignId>', campaignId));
    return response.data.campaign;
}
export const fetchPublicConversionCampaign = async (campaignId: string) : Promise<any> => {
    const response = await axiosClient.get(apiConfigs.FETCH_CONVERSION_CAMPAIGN_PUBLIC.url.replace('<campaignId>', campaignId));
    return response.data.campaign;
}
export const createConversionCampaignLink = async (campaignId: string, data: any): Promise<any> => {
    const response = await axiosClient.post(apiConfigs.ADD_CONVERSION_CAMPAIGN_LINK.url.replace('<campaignId>', campaignId), data);
    return response.data.link_id as number;
}

export const fetchConversionCampaignLinks = async (campaignId: string, data: any) : Promise<any> => {
    const response = await axiosClient.get(apiConfigs.FETCH_CONVERSION_CAMPAIGN_LINKS.url.replace('<campaignId>', campaignId), data);
    return response.data;
}

export const fetchConversionCampaignCommissions = async (payload: any): Promise<any> => {
    const response = await axiosClient.get(apiConfigs.FETCH_CONVERSION_CAMPAIGN_COMMISSION.url, {params: payload});
    return response.data;
}

export const fetchConversionCampaignLink = async (campaignId: string, linkId: number): Promise<ConversionCampaignLink> => {
    const response = await axiosClient.get(apiConfigs.FETCH_CONVERSION_CAMPAIGN_LINK.url.replace('<campaignId>', campaignId).replace('<linkId>', linkId.toString()));
    return response.data.link;
}

export const fetchConversionCampaignGroupedEarnings = async (): Promise<ConversionCampaignGroupedEarning[]> => {
    const response = await axiosClient.get(apiConfigs.CONVERSION_CAMPAIGN_GROUPED_EARNINGS.url);
    return response.data?.items ?? [];
}

export const optinConversionCampaign = async (campaignId: string): Promise<any> => {
    const response = await axiosClient.post(apiConfigs.OPTIN_CONVERSION_CAMPAIGN.url.replace('<campaignId>', campaignId));
    return response.data;
}